/* ═══════════════════════════════════════════════════════════
   PROD-LANDING.JS – Insta360 Colombia
   JS global para TODAS las landing pages de productos
   ───────────────────────────────────────────────────────────
   Este archivo va en: Shopify → Temas → Editar código → Assets
   Nombre del archivo: prod-landing.js
   
   Luego en theme.liquid, ANTES de </body>, agregar:
 
      {% if request.page_type == 'product' %}
        <script src="{{ 'prod-landing.js' | asset_url }}" defer></script>
      {% endif %}
   ═══════════════════════════════════════════════════════════ */
 
(function() {
  'use strict';
 
  /* ── 1. ACORDEÓN DE ESPECIFICACIONES ── */
  function initAccordion() {
    var buttons = document.querySelectorAll('.prod-accordion-btn');
    if (!buttons.length) return;
 
    buttons.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var item = btn.closest('.prod-accordion-item');
        var body = item.querySelector('.prod-accordion-body');
        var isOpen = item.classList.contains('is-open');
 
        document.querySelectorAll('.prod-accordion-item').forEach(function(other) {
          other.classList.remove('is-open');
          var ob = other.querySelector('.prod-accordion-body');
          if (ob) ob.classList.remove('open');
        });
 
        if (!isOpen) {
          item.classList.add('is-open');
          if (body) body.classList.add('open');
        }
      });
    });
  }
 
  /* ── 2. NAVEGACIÓN ACTIVA AL SCROLL ── */
  function initActiveNav() {
    var navLinks = document.querySelectorAll('.prod-nav-link');
    if (!navLinks.length) return;
 
    var sections = [];
    navLinks.forEach(function(link) {
      var href = link.getAttribute('href');
      if (href && href.charAt(0) === '#') {
        var section = document.querySelector(href);
        if (section) sections.push({ link: link, section: section });
      }
    });
    if (!sections.length) return;
 
    function update() {
      var scrollY = window.scrollY + 120;
      var current = sections[0];
      for (var i = 0; i < sections.length; i++) {
        if (sections[i].section.offsetTop <= scrollY) current = sections[i];
      }
      navLinks.forEach(function(l) { l.classList.remove('active'); });
      if (current) current.link.classList.add('active');
    }
 
    window.addEventListener('scroll', update, { passive: true });
    update();
  }
 
  /* ── 3. SCROLL SUAVE ── */
  function initSmoothScroll() {
    document.querySelectorAll('.prod-nav-link').forEach(function(link) {
      link.addEventListener('click', function(e) {
        var href = link.getAttribute('href');
        if (href && href.charAt(0) === '#') {
          e.preventDefault();
          var target = document.querySelector(href);
          if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }
 
  /* ── 4. LAZY LOADING DE VIDEOS ──
     En el HTML, en vez de:
       <video src="URL" autoplay loop muted playsinline>
     Poner:
       <video data-src="URL" autoplay loop muted playsinline class="prod-lazy-video">
     El video solo carga cuando el usuario está cerca de verlo.
  */
  function initLazyVideos() {
    var videos = document.querySelectorAll('.prod-lazy-video[data-src]');
    if (!videos.length) return;
 
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            var video = entry.target;
            video.src = video.getAttribute('data-src');
            video.removeAttribute('data-src');
            video.classList.remove('prod-lazy-video');
            observer.unobserve(video);
          }
        });
      }, { rootMargin: '200px' });
 
      videos.forEach(function(v) { observer.observe(v); });
    } else {
      videos.forEach(function(v) {
        v.src = v.getAttribute('data-src');
        v.removeAttribute('data-src');
      });
    }
  }
 
  /* ── INICIALIZAR TODO ── */
  function init() {
    initAccordion();
    initActiveNav();
    initSmoothScroll();
    initLazyVideos();
  }
 
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();